var _defs, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDpLogoGreen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 591 513",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}.cls-2{fill:url(#linear-gradient-2);}.cls-3{opacity:0.5;isolation:isolate;fill:url(#linear-gradient-3);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 404.458,
    y1: 31.901,
    x2: 404.458,
    y2: 358.254,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f6ca33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d97e06"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -590.396,
    y1: 639.788,
    x2: -590.396,
    y2: 631.65,
    gradientTransform: "matrix(21.981, 0, 0, -30.997, 13169.397, 20044.237)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#47ba3e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0d944a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -504.929,
    y1: 811.79,
    x2: -504.811,
    y2: 781.593,
    gradientTransform: "matrix(6.484, 0, 0, -1.838, 3678.056, 1878.206)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffe140"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f5a623"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "logo_green") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M404.445,31.909S254.856,28.415,254.856,170.352c0,84.123,67.514,140.338,119.006,175.259,10.544,7.166,22.854,12.643,30.583,12.643s20.052-5.477,30.6-12.643c51.493-34.934,119.019-91.123,119.019-175.259,0-141.937-149.6-138.444-149.6-138.444Zm0,197.947a63.623,63.623,0,1,1,63.623-63.623A63.623,63.623,0,0,1,404.445,229.855Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M288.92,32.031c-38.389-.024-38.389-.024-38.389,29.121l.162,97.4a151.291,151.291,0,0,0-58.79-11.812c-81.848,0-148.19,64.535-148.19,144.144S110.054,435,191.9,435a151.03,151.03,0,0,0,59.68-12.2c2.346,12.19,10.976,12.2,42.677,12.2,45.846,0,45.846,0,45.846-31.634V62.185L288.92,31ZM198.232,351.69a60.1,60.1,0,0,1-.014-120.209h.009a60.1,60.1,0,0,1,0,120.209Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M404.292,402.338c-22.905.307-41.409,5.822-41.319,12.323s18.734,11.491,41.652,11.171,41.409-5.835,41.319-12.323S427.2,402.018,404.292,402.338Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDpLogoGreen);
export default __webpack_public_path__ + "static/media/dp-logo-green.4aebee8951ba3e0a8f0b95ec4685ecf7.svg";
export { ForwardRef as ReactComponent };